import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Button from '../../../../components/Button/Button';
import Icon from '../../../../components/Icon/Icon';
var attachmentStyles = {
  root: function root(_ref) {
    var _focusVisible, _hover;

    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({}, (p.actionable || p.onClick) && {
      ':focus-visible': (_focusVisible = {
        backgroundColor: v.backgroundColorHover,
        color: v.textColorHover
      }, _defineProperty(_focusVisible, "& .".concat(Button.className), {
        color: v.textColorHover
      }), _defineProperty(_focusVisible, "& .".concat(Icon.className), {
        color: v.textColorHover
      }), _focusVisible),
      ':hover': (_hover = {}, _defineProperty(_hover, "& .".concat(Button.className), {
        color: v.textColorHover
      }), _defineProperty(_hover, "& .".concat(Icon.className), {
        color: v.textColorHover
      }), _hover)
    });
  }
};
export default attachmentStyles;